import type { ICellRendererParams } from 'ag-grid-community';
import { CopyValueCellComponent } from '@h20-shared/table-component/cell-renderer/individual/copy-value-cell/copy-value-cell.component';
import type {
    CopyableCellConfig,
    CopyableCellParams,
} from '@h20-shared/table-component/cell-renderer/individual/copy-value-cell/copy-value-cell.component';
import type { GridColumnSettings } from '../grid-column.types';
import type { RowActionLink } from '../row-actions/row-actions.types';

const SHORT_ID_LENGTH = 8;

export type IdColumnOptions<TRow> = {
    readonly copyConfig: CopyableCellConfig;
    /** Where clicking the ID goes. Return `null` to show the ID as plain text. */
    readonly getLink: (row: TRow) => RowActionLink | null;
};

export function idColumn<TRow>(options: IdColumnOptions<TRow>): GridColumnSettings<TRow> {
    const params: CopyableCellParams = {
        copyConfig: options.copyConfig,
        linkConfig: {
            getRouterLink: ({ data }: ICellRendererParams<TRow>) => {
                if (data === undefined) {
                    return undefined;
                }
                return options.getLink(data) ?? undefined;
            },
        },
    };
    return {
        flex: 0,
        width: 150,
        valueFormatter: ({ value }) =>
            typeof value === 'string' ? value.substring(0, SHORT_ID_LENGTH) : '',
        cellRenderer: CopyValueCellComponent,
        cellRendererParams: params,
    };
}
